import ProductTransformer from './ProductTransformer';

export default class ProductOrderSummaryOptinTransformer extends ProductTransformer {
  /** optin dialogs for order summary and order confirmation are identical in structure
   * to ordinary dialogs for order summary and order confirmation. Also, within
   * subscription template product content the optin dialogs contain fields having
   * same names and referencing correlated content as ordinary dialogs but tagged
   * with an additional keyword 'Optin'.
   * This transformer copies each tagged field to a field having a name w/o the keyword,
   * e.g. headerSubTitleOptinConfirmation is copied to eaderSubTitleConfirmation
   */
  static fetch(product, footnotes) {
    product = super.fetch(product, footnotes);

    const expression = new RegExp('optin', 'i');
    product = super.removeExpFromName(product, expression);

    if (product.price) product.price.promotion = null;
    product.texts.promotionPriceOverrideText = null;

    return product;
  }

  static addFootnote(fn, product) {
    if (fn.name === 'footNoteOptinSummary') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'productDescriptionOptinSummary',
      'providerName',
      'productRequirementsDetails',
      'priceInformation',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'afterOptinInfoText',
      'accountInfoTextOptinSummary',
      'emailTextProductOrder',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
    ['termsOrderLink', 'rescissionOrderLink'].forEach(field => {
      product.hyperlinks[field] = footnotes.parse(product.hyperlinks[field]);
    });
    if (product.textLists.textToBeConfirmedOptinSummary) {
      product.textLists.textToBeConfirmedOptinSummary.forEach((item, index) => {
        product.textLists.textToBeConfirmedOptinSummary[index] = footnotes.parse(product.textLists.textToBeConfirmedOptinSummary[index]);
      });
    }
  }
}
